module.exports = __webpack_public_path__ + "static/media/scale.fb6184ff.svg";